import React, { useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({
    title,
    text,
    onSubmit,
    open,
    onClose,
    confirmLabel,
    confirmColor,
}) => {
    const { t } = useTranslation();
    // const handleSubmit = () => {
    //     onSubmit();
    //     onClose();
    // };

    const handleSubmit = useCallback(() => {
        onSubmit();
    }, [onSubmit]);

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{text}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('buttonCommons.cancel')}</Button>
                <Button
                    onClick={() => {
                        handleSubmit();
                    }}
                    color={confirmColor || "primary"}
                >
                    {confirmLabel || t('buttonCommons.submit')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default ConfirmDialog;
